<template>
  <div style="background: #fff;height:100%;">
    <!-- 地址 -->
  <div v-show="onShowAddress">
    <div style="font-size:30px;font-weight:bold;color:#000;margin:35px 0 42px 118px;">Address Book</div>
    <div style="display:flex;flex-wrap:wrap;margin:0 78px 25px 118px;">
      <div style="max-width:calc(50% - 40px);border:1px solid #e1e1e1;display: flex;justify-content: center;padding: 26px 22px 36px 22px;margin-right:40px;margin-bottom:20px;box-sizing: border-box;" v-for="(item, index) in addressList" :key="index">
        <div style="flex:1;">
          <!-- <p v-if="item.defaultBill == 1" style="font-size:18px;color:#000;margin-bottom:26px;">Default Bill Address</p>
          <p v-else-if="item.defaultShipping == 1" style="font-size:18px;color:#000;margin-bottom:26px;">Default Shipping Address</p>
          <p v-else></p> -->
          <p v-if="item.defaultShipping == 1" style="font-size:18px;color:#000;margin-bottom:26px;">Default Shipping Address</p>
          <p v-if="item.defaultBill == 1" style="font-size:18px;color:#000;margin-bottom:26px;">Default Bill Address</p>
          <p style="font-size:16px;color:#8d8d8d;line-height:26px;">
            <span>{{ item.lastName }} </span> <span>{{ item.firstName }}</span>
          </p>
          <p style="font-size:16px;color:#8d8d8d;line-height:26px;">
            <span>{{ item.streetAddress }} </span> <span>{{ item.city }}</span> <span>{{ item.stateSelectState }}</span>
          </p>
          <p style="font-size:16px;color:#8d8d8d;line-height:26px;">
            <span>{{ item.countryUnitedStates }} </span>
          </p>
          <p style="font-size:16px;color:#8d8d8d;line-height:26px;">
            <span>{{ item.phone }} </span>
          </p>
        </div>
        <div style="flex:1;text-align:right;">
          <a class="a1" @click="checkAddressDefalt('shipping', item.id)" style="width:228px;height:30px;line-height:30px;text-align:center;background:#00718c;color:#fff;font-size:16px;margin-bottom:6px;display:block;float:right;">SET AS PRIMARY SHIPPING</a>
          <a class="a1" @click="checkAddressDefalt('bill', item.id)" style="width:228px;height:30px;line-height:30px;text-align:center;background:#00718c;color:#fff;font-size:16px;margin-bottom:50px;display:block;float:right;">SET AS PRIMARY BILLING</a>
          <p>
            <a @click="editAddress(item)" style="font-size:16px;color:#00546a;">EDITI</a>
            <span style="margin:0 6px;color:#d3d3d3;">|</span>
            <a @click="removeAddress(item)" style="font-size:16px;color:#00546a;">REMOVE</a>
          </p>
        </div>
      </div>
    </div>
    <a class="a1" @click="addAdress()" style="margin:0 0 100px 118px;width:194px;height:48px;line-height:48px;text-align:center;border-radius:6px;font-size:20px;font-weight:bold;color:#fff;background:#00718c;display:block;">+ Add Address</a>
  </div>
  <!-- 添加地址 -->
  <div v-show="onShowAdd">
    <div style="font-size:24px;color:#000;font-weight:bold;margin:35px 0 12px 120px;">{{title}}</div>
    <div style="font-size:18px;color:#000;margin: 0 0 20px 120px;">*Required Fields</div>
    <el-form autoComplete="on"
               :model="addressForm"
               :rules="addressRules"
               label-position="right" label-width="200px"
               ref="addressForm"
               class="box-content">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="addressDescription" label="Address Description">
              <el-input name="addressDescription" class="ipt"
                        type="text"
                        v-model="addressForm.addressDescription"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="countryUnitedStates" label="CountryUnited States">
              <el-input name="countryUnitedStates" class="ipt"
                        type="text"
                        v-model="addressForm.countryUnitedStates"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="firstName" label="First Name">
              <el-input name="firstName" class="ipt"
                        type="text"
                        v-model="addressForm.firstName"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="streetAddress" label="Street Address">
              <el-input name="streetAddress" class="ipt"
                        type="text"
                        v-model="addressForm.streetAddress"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="lastName" label="Last Name">
              <el-input name="lastName" class="ipt"
                        type="text"
                        v-model="addressForm.lastName"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="addressLine2" label="Address Line2">
              <el-input name="addressLine2" class="ipt"
                        type="text"
                        v-model="addressForm.addressLine2"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="company" label="Company">
              <el-input name="company" class="ipt"
                        type="text"
                        v-model="addressForm.company"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="addressLine3" label="Address Line3">
              <el-input name="addressLine3" class="ipt"
                        type="text"
                        v-model="addressForm.addressLine3"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="jobTitle" label="Job Title">
              <el-input name="jobTitle" class="ipt"
                        type="text"
                        v-model="addressForm.jobTitle"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="addressLine4" label="Address Line4">
              <el-input name="addressLine4" class="ipt"
                        type="text"
                        v-model="addressForm.addressLine4"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="phone" label="Phone">
              <el-input name="phone" class="ipt"
                        type="text"
                        v-model="addressForm.phone"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="city" label="City">
              <el-input name="city" class="ipt"
                        type="text"
                        v-model="addressForm.city"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="extension" label="Extension">
              <el-input name="extension" class="ipt"
                        type="text"
                        v-model="addressForm.extension"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="stateSelectState" label="State Select State">
              <el-input name="stateSelectState" class="ipt"
                        type="text"
                        v-model="addressForm.stateSelectState"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="fax" label="Fax">
              <el-input name="fax" class="ipt"
                        type="text"
                        v-model="addressForm.fax"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="postalCode" label="Postal Code">
              <el-input name="postalCode" class="ipt"
                        type="text"
                        v-model="addressForm.postalCode"
                        autoComplete="off"
                        placeholder="">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item prop="defaultBill" label="">
              <el-checkbox v-model="addressForm.defaultBill" label="defaultBill">DEFAULT BILLING ADDRESS</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="defaultShipping" label="">
              <el-checkbox v-model="addressForm.defaultShipping" label="defaultShipping">DEFAULT SHIPPING</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <a class="a1" v-if="title == 'Add Address'" style="padding:16px;text-align:center;background:#00718c;color:#fff;font-size:20px;font-weight:bold;border-radius:6px;" :loading="loading" @click="handleAddress">
            Add Address
          </a>
          <a class="a1" v-if="title == 'Edit Address'" style="padding:16px;text-align:center;background:#00718c;color:#fff;font-size:20px;font-weight:bold;border-radius:6px;" :loading="loading" @click="handleEditAddress">
            Edit Address
          </a>
        </el-form-item>
      </el-form>
  </div>
  </div>
</template>
<script>
    import { 
      addressList,
      addressDefault,
      addressDelete,
      addressDetail,
      addressAdd,
      addressUpdate,
    } from '@/api/Persona/index' ;
    const defaultAddress = {
      addressDescription: '',
      countryUnitedStates: '',
      firstName: '',
      streetAddress: '',
      lastName: '',
      addressLine2: '',
      company: '',
      addressLine3: '',
      jobTitle: '',
      addressLine4: '',
      phone: '',
      city: '',
      extension: '',
      stateSelectState: '',
      fax: '',
      postalCode: '',
      defaultBill: 0,
      defaultShipping: 0,
    };
    export default {
        name: 'Address',
        components: {},
        data () {
            return {
              title: '',
              addressForm: Object.assign({}, defaultAddress),
              addressRules: {
                countryUnitedStates: [{required: true, message: 'Enter', trigger: 'blur'}],
                firstName: [{required: true, message: 'Enter',trigger: 'blur'}],
                streetAddress: [{required: true, message: 'Enter',trigger: 'blur'}],
                lastName: [{required: true, message: 'Enter',trigger: 'blur'}],
                phone: [{required: true, message: 'Enter',trigger: 'blur'}],
                city: [{required: true, message: 'Enter',trigger: 'blur'}],
                stateSelectState: [{required: true, message: 'Enter',trigger: 'blur'}],
                postalCode: [{required: true, message: 'Enter',trigger: 'blur'}],
              },
              loading:false,
              onShowAddress: true,
              onShowAdd:false,
              addressList: [],
            }
        },
        methods: {
          getAddressList() {
              const params = {};
              addressList(params).then((res) => {
                console.log(res, 'addressList');
                this.addressList = res;
              });
          },
          checkAddressDefalt(type, id) {
            let params = {
              id: id,
              defaultBill:  0,
              defaultShipping: 0
            };
            console.log(type, 'type');
            if (type == 'shipping') {
              params.defaultBill = 0;
              params.defaultShipping = 1;
            } else {
              params.defaultBill = 1;
              params.defaultShipping = 0;
            }
            addressDefault(params).then((res) => {
              console.log(res, 'addressDefault');
              this.getAddressList();
            });
          },
          removeAddress(item) {
            addressDelete({ id: item.id }).then((res) => {
              console.log(res, 'addressDelete');
              this.getAddressList();
            });
          },
          editAddress(item) {
            addressDetail({ id: item.id }).then((res) => {
              console.log(res, 'addressDetail');
              this.title= 'Edit Address';
              this.onShowAddress = false;
              this.onShowAdd = true;
              this.addressForm = {...res}
              if (res.defaultBill == 1) {
                this.addressForm.defaultBill = true;
              } else {
                this.addressForm.defaultBill = false;
              }
              if (res.defaultShipping == 1) {
                this.addressForm.defaultShipping = true;
              } else {
                this.addressForm.defaultShipping = false;
              }
              console.log(this.addressForm, 'this.addressForm00');
            });
          },
          handleEditAddress() {
            this.$refs.addressForm.validate(valid => {
              if (valid) {
                this.loading = true;
                if (this.addressForm.defaultBill == true) {
                  this.addressForm.defaultBill = 1;
                } else {
                  this.addressForm.defaultBill = 0;
                }
                if (this.addressForm.defaultShipping == true) {
                  this.addressForm.defaultShipping = 1;
                } else {
                  this.addressForm.defaultShipping = 0;
                }
                addressUpdate(this.addressForm).then((res) => {
                    console.log(res, 'addressUpdate');
                    this.loading = false
                    this.onShowAddress = true;
                    this.onShowAdd = false;
                    this.getAddressList();
                }).catch(() => {
                    this.loading = false
                });
              } else {
                return false
              }
            })
          },
          addAdress() {
            this.title = 'Add Address';
            this.onShowAddress = false;
            this.onShowAdd = true;
          },
          handleAddress() {
            this.$refs.addressForm.validate(valid => {
              if (valid) {
                this.loading = true;
                if (this.addressForm.defaultBill == true) {
                  this.addressForm.defaultBill = 1;
                } else {
                  this.addressForm.defaultBill = 0;
                }
                if (this.addressForm.defaultShipping == true) {
                  this.addressForm.defaultShipping = 1;
                } else {
                  this.addressForm.defaultShipping = 0;
                }
                addressAdd(this.addressForm).then((res) => {
                    console.log(res, 'addressAdd');
                    this.loading = false
                    this.onShowAddress = true;
                    this.onShowAdd = false;
                    this.getAddressList();
                }).catch(() => {
                    this.loading = false
                });
              } else {
                return false
              }
            })
          },
        },
        mounted() {
          this.getAddressList();
        },
    }
</script>

<style scoped>
.box-content {
  margin:0 139px;
}
</style>